import { useQuery } from '@tanstack/react-query';
import { useLocalStorage } from 'usehooks-ts';
import { fetchReferralCodes } from '@/lib/db/DBReferralHelpers';
import { fetchReferrals, getReferrer } from '@/lib/db/DBReferralCodesHelpers';
import { fetchDBCloudWallet } from '@/lib/db/DBCloudWalletHelpers';
export const useUserCloudQuery = PKP => {
  const [userCloudDataLC, setUserCloudDataLC] = useLocalStorage('cloudUserData', null);
  const query = useQuery({
    queryKey: ['cloudUserData'],
    queryFn: async () => {
      if (!(PKP === null || PKP === void 0 ? void 0 : PKP.ethAddress)) return null;
      const data = await fetchDBCloudWallet();
      const dataToReturn = data.data ? data : null;
      setUserCloudDataLC(dataToReturn);
      return dataToReturn;
    },
    enabled: PKP && (PKP === null || PKP === void 0 ? void 0 : PKP.ethAddress) ? true : false,
    // Only fetch if ethAddress exists
    staleTime: 1000 * 60 * 5,
    // Cache for 5 minutes
    refetchOnWindowFocus: false
  });
  return Object.assign(Object.assign({}, query), {
    data: userCloudDataLC || query.data,
    isLoading: !userCloudDataLC && query.isLoading
  });
};
// Fetch referral codes and referrals
export const useReferralQuery = (PKP, cloudData) => {
  var _a;
  const [referralDataLC, setReferralDataLC] = useLocalStorage('referralData', null);
  const query = useQuery({
    queryKey: ['referrals', {
      codes: null,
      referrals: null
    }],
    queryFn: async () => {
      var _a, _b, _c, _d, _e;
      if (!(PKP === null || PKP === void 0 ? void 0 : PKP.ethAddress) || !((_a = cloudData.data) === null || _a === void 0 ? void 0 : _a.user_id)) return null;
      const referralCodesPromise = await fetchReferralCodes({
        ethAddress: PKP === null || PKP === void 0 ? void 0 : PKP.ethAddress
      });
      const referrerPromise = await getReferrer();
      const [referralCodes, referrer] = await Promise.all([referralCodesPromise, referrerPromise]);
      const codes = referralCodes.data && Array.isArray(referralCodes.data) && referralCodes.data.length > 0 ? referralCodes.data[0] : null;
      // Handle fetchReferrals with try/catch to prevent errors from stopping the whole function
      let referrals = null;
      let totalReferralVolume = null;
      try {
        const allReferrals = await fetchReferrals({
          refererUserId: (_b = cloudData === null || cloudData === void 0 ? void 0 : cloudData.data) === null || _b === void 0 ? void 0 : _b.user_id
        });
        const totalReferralVolumePayload = await fetch('/api/referrals/status?code=' + (codes === null || codes === void 0 ? void 0 : codes.referral_code));
        totalReferralVolume = (_c = await totalReferralVolumePayload.json()) === null || _c === void 0 ? void 0 : _c.orderValue;
        referrals = allReferrals && allReferrals.data && allReferrals.data.length > 0 ? allReferrals.data : null;
      } catch (error) {
        console.error('Failed to fetch referrals:', error);
        // If fetchReferrals fails, we keep referrals as null
      }
      setReferralDataLC({
        codes: codes,
        referrals: referrals,
        referrer: ((_d = referrer.data) === null || _d === void 0 ? void 0 : _d.eth_address) ? referrer.data : null,
        totalReferralVolume
      });
      return {
        codes: codes,
        referrals: referrals,
        totalReferralVolume,
        refferer: ((_e = referrer.data) === null || _e === void 0 ? void 0 : _e.eth_address) ? referrer.data : null
      };
    },
    enabled: PKP && cloudData && cloudData.data && !!(PKP === null || PKP === void 0 ? void 0 : PKP.ethAddress) && !!((_a = cloudData.data) === null || _a === void 0 ? void 0 : _a.user_id) ? true : false,
    staleTime: 1000 * 60 * 5,
    // Cache for 5 minutes
    refetchOnWindowFocus: false
  });
  return Object.assign(Object.assign({}, query), {
    data: referralDataLC || query.data,
    isLoading: !referralDataLC && query.isLoading
  });
};